import Script from "next/script"
import appPackage from "package.json"

const datadogCode = `(function(h,o,u,n,d) {
  h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
  d=o.createElement(u);d.async=1;d.src=n
  n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
})(window,document,'script','https://www.datadoghq-browser-agent.com/eu1/v5/datadog-rum.js','DD_RUM')
window.DD_RUM.onReady(function() {
  window.DD_RUM.init({
    clientToken: '${process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN}',
    applicationId: '${process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID}',
    site: 'datadoghq.eu',
    service: 'cr-vercel',
    env: '${process.env.NEXT_PUBLIC_DATADOG_ENV || "unknown"}',
    //  version: '1.0.0',
    version: '${appPackage.version}',
    sessionSampleRate: 20,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    compressIntakeRequest: true,

  })
});`

export default function Datadog() {
  return (
    <Script id="datadog-rum">
      {datadogCode}
    </Script>
  )
}

